import { Fragment } from "react"
import Grid  from "@material-ui/core/Grid"
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@material-ui/core/Checkbox';
import { FormControlLabel } from "@material-ui/core";
import TextField from '@material-ui/core/TextField';


const AdditionalInformation = ({
  feedbackRequired,
  handleFeedbackRequired,
  notificationTag,
  handleNotificationTag
}) => {
  return (
    <Fragment>
      <label className="title" style={{fontSize: "14px", fontWeight: "bold"}}>Additional Information</label>
      <div className="content-block position-relative" style={{ marginTop: "10px" }}>
        <div className="py-15">
          <Grid container style={{marginBottom: "20px"}}>
            <Grid item xs={2} style={{ marginLeft: "10px"}}>
              <label className="title" style={{ color: 'black', fontSize: '14px'}}>
              Feedback Required
              </label>
            </Grid>
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked = {feedbackRequired}
                    onChange={(e) => {
                      handleFeedbackRequired(e.target.checked)
                    }}
                    color="primary"
                  />
                }
                label={"Feedback Required"}
              />
            </Grid>
          </Grid>
          <Grid container style={{ marginBottom: "20px" }}>
            <Grid item xs={2} style={{ marginLeft: "10px", display: "flex", alignItems: "center" }}>
              <label className="title" style={{ color: 'black', fontSize: '14px' }}>
                Notification Tag
              </label>
            </Grid>
            <Grid item xs={4}>
              <TextField
                variant="standard"  
                style={{ height: '100px', padding: "10px" }}              
                placeholder="Enter Notification Tag"
                value={notificationTag}
                onChange={(e) => handleNotificationTag(e.target.value)}
                InputProps={{ disableUnderline: true }}
              />
            </Grid>
          </Grid>
        </div>
      </div>
    </Fragment>
  )
}

export default AdditionalInformation